module.exports = __webpack_public_path__ + "static/media/kpmg-hero-logo.5709d48a.png";